// extracted by mini-css-extract-plugin
export default {"wrap":"HF-z","fullWidth":"IF-z","hideOnDesktop":"JF-z","content":"KF-z","hasOpenedNav":"LF-z","crumbsList":"MF-z","dropdownsWrap":"NF-z"};